// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { TerceraChartCashItemSeriesDataType, TerceraChartCashItemSeriesDataTypeBasisType } from './TerceraChartCashItemSeriesEnums';
import { ChartDataType } from '../Utils/ChartConstants';
import { ChartSeriesLogDataConverter, ChartSeriesRelativeDataConverter } from './ChartSeriesDataConverter';
import { MathUtils } from '@shared/utils/MathUtils';
export class TerceraChartCashItemSeriesSettings {
    constructor(model) {
        this.profilePOCType = ProfilePOCTypesEnum.Marker;
        this.profileVAType = ProfileVATypesEnum.Vertical;
        this.clusterMinimumStep = 0; // расчетное поле (минимальный степ, чтобы текст не налезал)
        this.clusterCurrentStep = 0; // расчетное поле (текущий степ с учетом всех настроек)
        // Тип данных: абсолютные/относительные/логарифмические
        this.DataType = TerceraChartCashItemSeriesDataType.Absolute;
        // Откуда брать значения для расчета относительных шкал
        this.BasisType = TerceraChartCashItemSeriesDataTypeBasisType.BeginOfScreen;
        this.showVolume = true;
        this.UseTicksData = false;
        this.chartMVCModel = model;
        this.relativeDataConverter = new ChartSeriesRelativeDataConverter();
        this.logDataConverter = new ChartSeriesLogDataConverter();
    }
    get ActiveConverter() {
        if (this.DataType === TerceraChartCashItemSeriesDataType.Log) {
            return this.logDataConverter;
        }
        else if (this.DataType === TerceraChartCashItemSeriesDataType.Relative) {
            return this.relativeDataConverter;
        }
        else {
            return null;
        }
    }
    // #region Renderers
    get ShowEmptyBars() {
        const chartMVCModel = this.chartMVCModel;
        const tfInfo = chartMVCModel.GetTimeFrameInfo();
        return chartMVCModel.GetShowZeroes() && (!tfInfo || tfInfo.ChartDataType !== ChartDataType.HeikinAshi);
    }
    // #endregion
    CalculateConverter(value) {
        switch (this.DataType) {
            case TerceraChartCashItemSeriesDataType.Absolute:
                return value;
            case TerceraChartCashItemSeriesDataType.Relative:
                return this.relativeDataConverter.Calculate(value);
            case TerceraChartCashItemSeriesDataType.Log:
                return this.logDataConverter.Calculate(value);
        }
    }
    RevertConverter(value) {
        switch (this.DataType) {
            case TerceraChartCashItemSeriesDataType.Absolute:
                return value;
            case TerceraChartCashItemSeriesDataType.Relative:
                return this.relativeDataConverter.Revert(value);
            case TerceraChartCashItemSeriesDataType.Log:
                return this.logDataConverter.Revert(value);
        }
    }
    FormatPriceConverter(value, instrument, dataType = null) {
        const dt = dataType !== null && dataType !== void 0 ? dataType : this.DataType;
        switch (dt) {
            case TerceraChartCashItemSeriesDataType.Absolute:
                return instrument.formatPrice(instrument.roundPrice(value));
            case TerceraChartCashItemSeriesDataType.Relative:
                return this.RelativeFormatPrice(value);
            case TerceraChartCashItemSeriesDataType.Log:
                return instrument.formatPrice(instrument.roundPrice(this.logDataConverter.Revert(value)));
        }
    }
    FormatPriceScaleConverter(value, instrument, dataType = null) {
        const dt = dataType !== null && dataType !== void 0 ? dataType : this.DataType;
        let roundValue = MathUtils.RoundDouble(value, instrument.Precision);
        switch (dt) {
            case TerceraChartCashItemSeriesDataType.Absolute:
                return instrument.formatPrice(roundValue, false);
            case TerceraChartCashItemSeriesDataType.Relative:
                return this.RelativeFormatPrice(value);
            case TerceraChartCashItemSeriesDataType.Log:
                roundValue = MathUtils.RoundDouble(this.logDataConverter.Revert(value), instrument.Precision);
                return instrument.formatPrice(roundValue, false);
        }
    }
    RelativeFormatPrice(value) {
        return (Math.abs(value) < 0.005 ? '0.00' : value.toFixed(2)) + '%';
    }
}
export var ProfilePOCTypesEnum;
(function (ProfilePOCTypesEnum) {
    ProfilePOCTypesEnum[ProfilePOCTypesEnum["None"] = 0] = "None";
    ProfilePOCTypesEnum[ProfilePOCTypesEnum["Marker"] = 1] = "Marker";
    ProfilePOCTypesEnum[ProfilePOCTypesEnum["Line"] = 2] = "Line";
})(ProfilePOCTypesEnum || (ProfilePOCTypesEnum = {}));
export var ProfileVATypesEnum;
(function (ProfileVATypesEnum) {
    ProfileVATypesEnum[ProfileVATypesEnum["None"] = 0] = "None";
    ProfileVATypesEnum[ProfileVATypesEnum["Vertical"] = 1] = "Vertical";
    ProfileVATypesEnum[ProfileVATypesEnum["Horizontal"] = 2] = "Horizontal";
    ProfileVATypesEnum[ProfileVATypesEnum["ToNextProfile"] = 3] = "ToNextProfile";
})(ProfileVATypesEnum || (ProfileVATypesEnum = {}));
